import { render } from "./QrCode.vue?vue&type=template&id=6ca1adba"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"
script.render = render

export default script